











import EventBus from '@/event-bus';

import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';

import { Editor } from '@toast-ui/vue-editor';

export default {
  components: {
    editor: Editor
  },
  props: {
    id: {
      type: Number
    },
  },
  mounted() {
    EventBus.$on('dataEditor', (data: any) => {
      if (data.id == this.id && this.$refs.toastuiEditor != null) {
        this.$refs.toastuiEditor.invoke('setMarkdown', data.info);
      }
    });
  },
  data() {
    return {
      editorOptions: {
        language: 'en-US',
        useCommandShortcut: true,
        useDefaultHTMLSanitizer: true,
        usageStatistics: false,
        hideModeSwitch: true,
        toolbarItems: [
          'heading',
          'bold',
          'italic',
          'strike',
          'divider',
          'hr',
          'quote',
          'divider',
          'ul',
          'ol',
          'task',
          'divider',
          'table',
          'image',
          'link',
          'divider',
          'code',
          'codeblock'
        ]
      }
    }
  },
  methods: {
    getMarkdown() {
      let data = this.$refs.toastuiEditor.invoke('getMarkdown');
      return data != null ? data : '';
    },
    onChangeEditor() {
      this.$emit('change', this.getMarkdown());
    }
  }
};
